const RESPONSE_VALID = 'N';
const RESPONSE_ERROR = 'error_auth_login';
const STATUS = '1';
const MSG = 'ERROR';
const ERROR_TYPE = 'internal';
const ERROR_CODE = 'user_login_invalido';
const ERROR_DESCRIPTION =
  'El usuario o contraseña ingresado es incorrecto, favor de intentarlo nuevamente.';

const invalidPassword = async error => {
  const { response, ...customResponseData } = error;

  const newError = {
    response: {
      valido: RESPONSE_VALID,
      error: RESPONSE_ERROR,
    },
    status: STATUS,
    msg: MSG,
    errors: {
      type: ERROR_TYPE,
      error: [ERROR_DESCRIPTION],
      code: ERROR_CODE,
    },
  };

  const newResponse = { ...customResponseData, ...newError };
  // eslint-disable-next-line no-param-reassign
  error.response.data = newResponse;
};

export default invalidPassword;
